import { Layout } from "antd";

function Footer() {
  const { Footer: AntFooter } = Layout;
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter className="app-footer">
      <span className="app-copyright">
        &copy; {currentYear} {process.env.REACT_APP_COMPANY_NAME_FULL || "Royal Building Solutions (Pvt) Ltd"} &middot; Powered by{" "}
        <a href="https://autone.lk" target="_blank" rel="noopener noreferrer">
          Autone
        </a>
      </span>
    </AntFooter>
  );
}

export default Footer;
